export function noop() {
  // Do nothing
}
